<template>
    <div style="padding-top:40px">
        <nav-bar
            title="农户详情"
            fixed
            @click-left="back"
        />
        <div class="line_t"></div>
        <div class="base_info">
            <div class="title">基本信息</div>
            <div class="flex_start info_1">
                <div class="avar">
                    <img :src="detail.header_img" alt="">
                </div>
                <div class="info_2 flex_bewteen">
                    <div class="flex_start">
                        <div>真实姓名：</div>
                        <div class="inf">{{detail.real_name}}</div>
                    </div>
                    <div class="flex_start">
                        <div>微信昵称：</div>
                        <div class="inf">{{detail.nick_name}}</div>
                    </div>
                    <div class="flex_start">
                        <div>注册时间：</div>
                        <div class="inf">{{detail.created_at}}</div>
                    </div>
                </div>
            </div>
            <div class="info_3 flex_bewteen">
                <div class="flex_start">
                    <div>种植亩数：</div>
                    <div class="inf">{{detail.plant_mu}}亩</div>
                </div>
                <div class="flex_start mzw">
                    <div>种植农作物：</div>
                    <div class="inf mzw_1">{{detail.plant_crop}}</div>
                </div>
                <div class="flex_start">
                    <div>购买总数：</div>
                    <div class="inf">{{detail.buy_amount}}袋</div>
                </div>
            </div>
        </div>
        <div class="line_t"></div>
        <div class="product_info">
            <div class="product_title">产品购买信息</div>
            <div class="flex_start pro_box_2">
                <div class="xh">序号</div>
                <div class="time">购买时间</div>
                <div class="pro">购买产品</div>
            </div>
            <div class="flex_start pro_box_2" v-for="item in list" :key="item.buy_time">
                <div class="xh">{{item.sort}}</div>
                <div class="time">{{item.buy_time}}</div>
                <div class="pro one_line">{{item.product_name}}</div>
            </div>
            <div class="no_info" v-if="list.length==0">暂无数据</div>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api'
import tools from '@/mixins/tools'
import NavBar from '@/components/navBar'
export default {
    data: () => {
        return {
            detail: {},
            list: []
        }
    },
    components: {
        NavBar
    },
    mixins: [tools],
    mounted() {
        this.loading()
        api.getFarmerDetail({ id: this.getQueryString('id') }).then(res => {
            this.detail = res.data
            api.getFarmerPurchHis({ id: this.getQueryString('id') }).then(res => {
                this.hideLoading()
                console.log(res.data)
                this.list = res.data
            })
        })
    },
    methods: {
        getQueryString(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
            var r = window.location.search.substr(1).match(reg)
            if (r != null) {
                return unescape(r[2])
            }
            return null
        }
    }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
